import TrederoCustom from './TrederoCustomKYCForm';

export default TrederoCustom;
